export default {
    path: 'home',
    name: 'home',
    component: () => import('@/pages/home/HomeIndex'),
    meta: {title: '系统信息'},

}
